// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CaseDocumentRelationshipModel {
    static getAttributeTypeMap() {
        return CaseDocumentRelationshipModel.attributeTypeMap;
    }
}
CaseDocumentRelationshipModel.discriminator = undefined;
CaseDocumentRelationshipModel.attributeTypeMap = [
    {
        "name": "documentId",
        "baseName": "documentId",
        "type": "number"
    },
    {
        "name": "comment",
        "baseName": "comment",
        "type": "string"
    }
];
//# sourceMappingURL=caseDocumentRelationshipModel.js.map